import { combineReducers } from '@reduxjs/toolkit';

import popular from './reducers/popularDestinations';
import suggests, { actions as suggestsActions } from './reducers/suggests';

const reducer = combineReducers({
  popular,
  suggests,
});

export default reducer;

export type SharedState = ReturnType<typeof reducer>;

export const trackingTypes = {
  suggestsSuccess: suggestsActions.fetch.fulfilled.type,
  suggestsFailed: suggestsActions.fetch.rejected.type,
  suggestsRequested: suggestsActions.fetch.pending.type,
  suggestsEmpty: suggestsActions.trackEmptySuggests.type,
};
